import { render, staticRenderFns } from "./ContainerInformacoes.vue?vue&type=template&id=abee169c&scoped=true&lang=pug"
import script from "./ContainerInformacoes.vue?vue&type=script&lang=js"
export * from "./ContainerInformacoes.vue?vue&type=script&lang=js"
import style0 from "./ContainerInformacoes.vue?vue&type=style&index=0&id=abee169c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abee169c",
  null
  
)

export default component.exports